var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 13.1245H10.9375V9.68701C10.9375 9.1792 10.5078 8.74951 10 8.74951H8.75C8.20312 8.74951 7.8125 9.1792 7.8125 9.68701C7.8125 10.2339 8.20312 10.6245 8.75 10.6245H9.0625V13.1245H8.4375C7.89063 13.1245 7.5 13.5542 7.5 14.062C7.5 14.6089 7.89063 14.9995 8.4375 14.9995H11.5625C12.0703 14.9995 12.5 14.6089 12.5 14.062C12.5 13.5542 12.0703 13.1245 11.5625 13.1245ZM10 7.49951C10.6641 7.49951 11.25 6.95264 11.25 6.24951C11.25 5.58545 10.6641 4.99951 10 4.99951C9.29688 4.99951 8.75 5.58545 8.75 6.24951C8.75 6.95264 9.29688 7.49951 10 7.49951Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.79951C5.45181 1.79951 1.8 5.48123 1.8 9.99951C1.8 14.5523 5.44724 18.1995 10 18.1995C14.5183 18.1995 18.2 14.5477 18.2 9.99951C18.2 5.48581 14.5137 1.79951 10 1.79951ZM10 -0.000488281C4.45312 -0.000488281 0 4.4917 0 9.99951C0 15.5464 4.45312 19.9995 10 19.9995C15.5078 19.9995 20 15.5464 20 9.99951C20 4.4917 15.5078 -0.000488281 10 -0.000488281Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.75a66e830782c039e896ad6a67cba1b7.svg";
export { ForwardRef as ReactComponent };